import { SCREEN_NAMES } from 'src/constants';

export const createDynamicFieldObj = async (calledFrom, selectedCustomers = [], selectedCustomersParties = [], selectedParties = [], selectedCustomersGroups = [], selectedGroups = []) => {
  // Check to see if all partyId elements are the same.
  const partyId = () => {
    switch (calledFrom) {
      case SCREEN_NAMES.EVENT_GUEST_LIST:
        return selectedCustomersParties.every((v, i, a) => i === 0 || v === a[i - 1]) ? selectedCustomersParties[0] : null;
      case SCREEN_NAMES.EVENT_LIST:
        return selectedParties.length === 1 ? selectedParties[0] : null;
      default:
        return null;
    }
  };

  const groupId = () => {
    switch (calledFrom) {
      case SCREEN_NAMES.GROUP_CONTACT_LIST:
        return selectedCustomersGroups.every((v, i, a) => i === 0 || v === a[i - 1]) ? selectedCustomersGroups[0] : null;
      case SCREEN_NAMES.GROUP_LIST:
        return selectedGroups.length === 1 ? selectedGroups[0] : null;
      default:
        return null;
    }
  };

  switch (calledFrom) {
    case SCREEN_NAMES.CONTACT_LIST:
      return {
        calledBy: selectedCustomers.length === 1 ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: selectedCustomers.length === 1 ? selectedCustomers[0] : null,
      };

    case SCREEN_NAMES.EVENT_GUEST_LIST:
      return {
        calledBy: partyId() ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: selectedCustomers.length === 1 ? selectedCustomers[0] : null,
        partyId: partyId(),
      };

    case SCREEN_NAMES.EVENT_LIST:
      return {
        calledBy: partyId() ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: null,
        partyId: partyId(),
      };

    case SCREEN_NAMES.GROUP_CONTACT_LIST:
      return {
        calledBy: groupId() ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: selectedCustomers.length === 1 ? selectedCustomers[0] : null,
        partyId: null,
        groupId: groupId(),
      };

    case SCREEN_NAMES.GROUP_LIST:
      return {
        calledBy: groupId() ? 'fillFields' : 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: null,
        partyId: null,
        groupId: groupId(),
      };

    default:
      return {
        calledBy: 'Client',
        screenCalledFrom: calledFrom,
        distShort: false,
        contactId: null,
        partyId: null,
        groupId: null,
      };
  }
};
